var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.6562C8.34772 10.6562 10.6562 8.34772 10.6562 5.5C10.6562 2.65228 8.34772 0.34375 5.5 0.34375C2.65228 0.34375 0.34375 2.65228 0.34375 5.5C0.34375 8.34772 2.65228 10.6562 5.5 10.6562Z",
    stroke: "black",
    strokeWidth: 0.6875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50052 2.33325C5.13298 2.33325 4.83398 2.63245 4.83398 3.00022C4.83398 3.36765 5.13298 3.66659 5.50052 3.66659C5.86805 3.66659 6.16705 3.36765 6.16705 3.00022C6.16705 2.63245 5.86805 2.33325 5.50052 2.33325Z",
    fill: "#151B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.6665C5.22387 4.6665 5 4.89037 5 5.1665V8.1665C5 8.44264 5.22387 8.6665 5.5 8.6665C5.77613 8.6665 6 8.44264 6 8.1665V5.1665C6 4.89037 5.77613 4.6665 5.5 4.6665Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default ForwardRef;